var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardWrap clearfix" },
    [
      _c(
        "div",
        {
          staticClass: "cardText clearfix",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.titleHandle.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticStyle: { float: "left" } }, [_vm._t("default")], 2),
          _c(
            "div",
            {
              staticClass: "logoAndStar clearfix",
              staticStyle: { "margin-right": "16px" },
            },
            [
              _vm.baseData.logoPath
                ? _c("div", { staticClass: "logo" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.repliceHttps(_vm.baseData.logoPath),
                        alt: "",
                        srcset: "",
                      },
                      on: {
                        "~error": function ($event) {
                          _vm.baseData.logoPath = null
                        },
                      },
                    }),
                  ])
                : _c(
                    "div",
                    {
                      class: [
                        "logo2",
                        { aliasLineHeight: _vm.aliasLineHeight },
                      ],
                      style: "background:" + _vm.backgroundColor,
                    },
                    [_vm._v(_vm._s(_vm.setLineHeight(_vm.baseData.alias)))]
                  ),
            ]
          ),
          _c("div", { staticClass: "details" }, [
            _c(
              "div",
              {
                staticClass: "nameWrap mb-10",
                staticStyle: { display: "flex", "margin-bottom": "8px" },
              },
              [
                _c("span", {
                  staticClass: "name textOverflow",
                  staticStyle: {
                    "font-size": "15px",
                    "font-weight": "bold",
                    "line-height": "20px",
                  },
                  domProps: { innerHTML: _vm._s(_vm.companyNameColor || "--") },
                }),
                _vm.baseData.regStatus
                  ? _c(
                      "el-tag",
                      {
                        staticStyle: { color: "#30BF78" },
                        attrs: { size: "mini", type: "success" },
                      },
                      [_vm._v(_vm._s(_vm.baseData.regStatus))]
                    )
                  : _vm._e(),
                _vm.baseData.unlockType === 2
                  ? _c("div", { staticClass: "playGet font-12" }, [
                      _vm._v("赠"),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "star ml-10" }, [
                  _c("div", {
                    class: ["bg", { unstar: !_vm.baseData.star }],
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleStarB.apply(null, arguments)
                      },
                    },
                  }),
                ]),
              ],
              1
            ),
            _vm.baseData.tags
              ? _c(
                  "div",
                  { staticStyle: { display: "none", "flex-wrap": "wrap" } },
                  _vm._l(_vm.baseData.tags.split(","), function (tag, i) {
                    return _c("p", { key: i, staticClass: "tag-title" }, [
                      _vm._v(_vm._s(tag)),
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _c("dl", { staticClass: "text" }, [
              _c("dd", { staticClass: "mr-10" }, [
                _c("div", { staticClass: "textOverflow" }, [
                  _c("span", [_vm._v("成立日期：")]),
                  _vm.baseData.establishTime
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatTime")(_vm.baseData.establishTime)
                          )
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatTime")(_vm.baseData.estiblishTime)
                          )
                        ),
                      ]),
                ]),
                _c("div", { staticClass: "textOverflow" }, [
                  _c("span", [_vm._v("所属行业：")]),
                  _c("span", { attrs: { title: _vm.companyIndustry } }, [
                    _vm._v(_vm._s(_vm.companyIndustry)),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "address textOverflow2" }, [
              _c("span", [_vm._v("注册地址：")]),
              _c("span", {
                domProps: { innerHTML: _vm._s(this.address || "--") },
              }),
            ]),
          ]),
        ]
      ),
      _vm.drawerShow !== null
        ? _c("ViewNumber", {
            ref: "vNumber",
            attrs: { show: _vm.drawerShow, companyStatus: _vm.companyStatus },
            on: {
              "update:show": function ($event) {
                _vm.drawerShow = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }